import {RaEvent, RaEventType} from "./RaEvent";

export class WordWallLaunchEvent extends RaEvent {
    static TYPE: RaEventType = "wordwall_launch_event";

    constructor(private _isGuided:boolean) {
        super(WordWallLaunchEvent.TYPE);
    }
    public get isGuided(): boolean {
        return this._isGuided;
    }
}

export class WordWallCompleteEvent extends RaEvent {
    static TYPE: RaEventType = "wordwall_complete_event";

    constructor() {
        super(WordWallCompleteEvent.TYPE);
    }
}

